<div class="header">
  <h3>{{'PRODUCT.LIST.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row mb-2">
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" id="product_id" [(ngModel)]="searchProductID"
               placeholder="{{'HISTORY.PRODUCT-ID' | translate}}">
        <label for="product_id">{{'HISTORY.PRODUCT-ID' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" id="product_name" [(ngModel)]="searchProductName"
               placeholder="{{'HISTORY.PRODUCT-NAME' | translate}}">
        <label for="product_name">{{'HISTORY.PRODUCT-NAME' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" id="department_name" [(ngModel)]="searchProductDept"
               placeholder="{{ 'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate }}">
        <label for="product_id">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}</label>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="optionChanged()"
    *ngIf="loading === false && totalItems !== 0"
  >
    <button type="button" class="btn btn-dv btn-wide"
            (click)="openModal(null, -1)">{{'TEXT.ADD_PRODUCT' | translate}}</button>
  </app-custom-pagination>

  <div class="float-right" *ngIf="totalItems === 0 && loading === false">
    <button type="button" class="btn btn-dv btn-wide"
            (click)="openModal(null, -1)">{{'TEXT.ADD_PRODUCT' | translate}}</button>
  </div>
  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="scrollable m-t-30">
    <table class="table text-center" *ngIf="totalItems!== 0 && loading === false">
      <thead>
      <tr>
        <th>{{'COMMON.TABLE.ORDER' | translate}}</th>
        <th>{{'PRODUCT.LIST.FILTER.PRODUCT-ID' | translate}}</th>
        <th>{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}}</th>
        <th>{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}</th>
        <th>{{'TABLE.EDIT' | translate}}</th>
        <th>{{'TABLE.DELETE' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let product of productDetails; let index = index">
        <td>{{index +1}}</td>
        <td (click)="openModal(product, product.id)">{{product.product_id}}</td>
        <td>{{ lang === 'th' ? product.name_th : product.name_en }}</td>
        <td *ngIf="lang === 'th'" class="text-left">
          <ul class="mb-0">
            <li *ngFor="let name_th of product.department_name_th">{{name_th}}</li>
          </ul>
        </td>
        <td *ngIf="lang !== 'th'" class="text-left">
          <ul class="mb-0">
            <li *ngFor="let name_en of product.department_name_en">{{name_en}}</li>
          </ul>
        </td>
        <td>
          <i class="fa fa-1x fa-edit text-warning pointer" (click)="openModal(product, product.id)"></i>
        </td>
        <td>
          <i class="fa fa-1x fa-trash text-danger pointer" (click)="confirmDelete(index)"></i>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<product-list-detail #detailModal></product-list-detail>

<ng-template #deleteConfirmation let-modal>
  <div class="modal-header">
    <h5>{{'COMMON.CONFIRMATION'|translate}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h6>{{'NORMAL.PRODUCT-ID'| translate}}: {{ modalData.product_id }}({{modalData.name_en}})</h6>
        <h6>{{'COMMON.CONFIRM-DELETE-PRODUCT'| translate}}</h6>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="confirmedDelete(modalData.id)">
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>




// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.html